var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Reservations.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-705ac834\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Reservations.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/home/fabio/Documents/Work/Pluralo/Pluralo Business/Supplier/src/components/reservations/Reservations.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Reservations.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-loader/node_modules/vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-705ac834", Component.options)
  } else {
    hotAPI.reload("data-v-705ac834", Component.options)
  }
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/reservations/Reservations.vue
// module id = 1692
// module chunks = 0